import { useContext } from 'react';
import { useStore } from 'zustand';
import { CellEntryContext } from './context';
import { CellEntryState } from '../../store';
import { ICellEntry } from '@/store';

export const useCellEntryContext = <T>(
  selector: (state: CellEntryState & ICellEntry) => T,
  equalityFn?: (left: T, right: T) => boolean
): T => {
  const store = useContext(CellEntryContext);
  if (!store) throw new Error('Missing EntryContext.Provider in the entry');
  return useStore(store, selector, equalityFn);
};
